import { CustomizationValueDataImage } from './CustomizationValueDataImage';

export class CustomizationValue {

  public partIdentifier : string = '';
  public customizationID : string = '';
  public data : CustomizationValueDataImage | undefined;

  static create(
    partIdentifier : string,
    customizationID : string,
    data : CustomizationValueDataImage | undefined,
  ) {
    return {
      partIdentifier,
      customizationID,
      data,
    };
  }

  static getPartIdentifier(customizationValue : CustomizationValue) {
    return customizationValue.partIdentifier;
  }

  static getCustomizationID(customizationValue : CustomizationValue) {
    return customizationValue.customizationID;
  }

  static getData(customizationValue : CustomizationValue) {
    return customizationValue.data;
  }

  static setData(customizationValue : CustomizationValue, data : CustomizationValueDataImage) {
    // eslint-disable-next-line no-param-reassign
    customizationValue.data = data;
  }
}
